import React, { useEffect, useState } from "react";
import AppNavbar from "../../components/common/AppNavbar";
import { fetchNewsByCategory } from "../../services/api";
import Loading from "../../components/common/Loading";
import NewsSection from "../../components/home/NewsSection";
import YouTubeVideoList from "../../components/Entertainment/YouTubeVideoList";
import MovieList from "../../components/Entertainment/Movie";
import { Helmet } from "react-helmet";

function Entertainment() {
  const [entertainmentNews, setEntertainmentNews] = useState([]);
  const [gossipNews, setGossipNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      const [entertainmentData, gossipData] = await Promise.all([
        fetchNewsByCategory("entertainment"),
        fetchNewsByCategory("gossip"),
      ]);

      setEntertainmentNews(entertainmentData);
      setGossipNews(gossipData);
      setLoading(false);
    }
    load();
  }, []);

  if (loading) return <Loading />;

  return (
    <>
      <Helmet>
        <title>
          Bollywood & South Movies News | OTT, Celebrity Updates – BharatAbroad
        </title>
        <meta
          name="title"
          content="Bollywood & South Movies News | OTT, Celebrity Updates – BharatAbroad"
        />
        <meta
          name="description"
          content="Explore the latest entertainment news including Bollywood gossip, South Indian movies, OTT releases, web series, and celebrity updates on BharatAbroad."
        />
        <meta
          name="keywords"
          content="Bollywood news today, OTT India releases, South Indian cinema news, Tollywood box office, Indian web series 2026, Bollywood breaking news live, Celebrity news India today, Indian OTT trending shows 2026, Netflix India new releases, Amazon Prime India latest series, South cinema box office collection, Tamil movies latest news, Telugu cinema updates today, Bollywood box office collection today, Upcoming Bollywood movies 2026, Bollywood movie reviews India, Hindi cinema latest updates, Celebrity interviews India, Bollywood controversies latest, Filmfare awards news India, National film awards India news, Indian film industry news, Movie release dates India 2026, Trailer launch Bollywood today, Music release Bollywood songs, Indian playback singers news, Reality shows India updates, Bigg Boss India news, Indian TV serial updates, TRP ratings India shows, OTT vs theatre debate India, Streaming platforms India news, Disney+ Hotstar India releases, SonyLIV India new shows, ZEE5 India latest series, Regional OTT platforms India, Malayalam cinema news today, Kannada cinema updates today, Pan India movies news, Box office collection India today, Highest grossing Indian movies, Movie ticket booking trends India, Cinema hall reopening news India, Film industry business India, Celebrity net worth India, Celebrity lifestyle India news, Celebrity weddings India news, Star kids Bollywood news, Influencers India entertainment news, YouTube creators India news, Social media trends India celebrities, Viral videos India entertainment, Meme trends India entertainment, BharatAbroad entertainment, BharatAbroad Bollywood, BharatAbroad OTT news"
        />

        {/* Technical */}
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta charSet="UTF-8" />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Bollywood & South Movies News | OTT, Celebrity Updates – BharatAbroad"
        />
        <meta
          property="og:description"
          content="Explore Bollywood and South Indian cinema news, OTT releases, web series updates, celebrity gossip, and box office trends on BharatAbroad."
        />
        <meta property="og:site_name" content="BharatAbroad" />
        <meta
          property="og:url"
          content="https://www.bharatabroad.com/entertainment"
        />
        <meta
          property="og:image"
          content="https://ayg.s3.us-east-2.amazonaws.com/bharatabroad.com-technologys.webp"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Bollywood & South Movies News | OTT, Celebrity Updates – BharatAbroad"
        />
        <meta
          name="twitter:description"
          content="Explore Bollywood and South Indian cinema news, OTT releases, web series updates, celebrity gossip, and box office trends on BharatAbroad."
        />
        <meta
          name="twitter:image"
          content="https://ayg.s3.us-east-2.amazonaws.com/bharatabroad.com-entertainment.png"
        />
        <meta name="twitter:site" content="@BharatAbroad" />

        {/* Canonical */}
        <link
          rel="canonical"
          href="https://www.bharatabroad.com/entertainment"
        />
      </Helmet>
      <AppNavbar />
      <div style={{ padding: "20px" }}>
        <div id="container">
          <MovieList />
          <NewsSection
            title="Celebrity News"
            articles={gossipNews}
            category="gossip"
          />
        </div>
        <YouTubeVideoList />
        {/* Gossip Section */}
        <NewsSection
          title="Entertainment News"
          articles={entertainmentNews}
          category="entertainment"
        />
      </div>
    </>
  );
}

export default Entertainment;
